import React, { forwardRef, useState, useEffect } from "react";
import { translate } from "../../../Services/translation";
import DatePicker from "react-datepicker";

export const LastLensCheckDate = (props) => {
    let initialAvailableDate = {
        mindate: new Date(),
        maxdate: new Date()
    }    
    const [availableDates, setavailableDates] = useState(initialAvailableDate);

    useEffect(() => {
        const currentFullDate = new Date();
        const availableFullDate = new Date(currentFullDate.getFullYear() - 1, currentFullDate.getMonth(), currentFullDate.getDate());
        setavailableDates({mindate: availableFullDate, maxdate: currentFullDate});
    }, []);

    const DatePickerInput = forwardRef((data, ref) => {
        const [readOnly, setReadOnly] = useState(false);
        return (
            <div className='date-picker-input-wrapper store-field-wrapper arrow-down_icon-wrapper' onClick={data.onClick} ref={ref} >
                <input className="register__datepicker-input" placeholder={data.placeholder} autoComplete="off" value={props.lastLensCheckDate} onChange={data.onChange}
                        onFocus={() => setReadOnly((window.innerWidth <= 760))}
                        onBlur={() => setReadOnly(false)}
                        readOnly={readOnly} />
                <div className="register__datepicker-icon" />
            </div>
        );
    });
    
    return (
        <>
            <div>
                <div className="column small-12 registration-page__last-check-description">
                    {translate("coptikk.register.lastlenscheckdescription")}
                </div>
            </div>
            <div>
                <div className="column small-12 registration-page__last-check-validation">
                    <input type="checkbox" onChange={(e) => props.setwithin12months(e.target.checked)} checked={props.within12months}></input>
                    <label>{translate("coptikk.register.undertwelvemonthstext")}</label>
                </div>
            </div>
            {props.validationErrors && props.validationErrors.lastLensCheckDate && <div className="column error">
                {translate("coptikk.register.lastlenscheckdatemandatory")}
                </div>}
            {props.within12months && <div>
                <div className="column medium-6 small-12">
                    {window.innerWidth <= 760 ?
                        <DatePicker                            
                            dateFormat="dd.MM.yyyy"
                            placeholderText={translate("coptikk.register.selectdate")}                            
                            locale="nb"
                            minDate={availableDates.mindate}
                            maxDate={availableDates.maxdate}
                            onChange={(date) => props.setLastLensCheckDate(date)}
                            popperClassName="booking"
                            customInput={<DatePickerInput />}                            
                        /> : <DatePicker                            
                            dateFormat="dd.MM.yyyy"
                            placeholderText={translate("coptikk.register.selectdate")}                            
                            locale="nb"
                            minDate={availableDates.mindate}
                            maxDate={availableDates.maxdate}
                            onChange={(date) => props.setLastLensCheckDate(date)}
                            customInput={<DatePickerInput />}
                        />}
                </div>
            </div>}
        </>
    )
}